class Rules {
  get(rule: $TSFixMe, a: $TSFixMe, b: $TSFixMe, c: $TSFixMe) {
    // @ts-expect-error TS(7052) FIXME: Element implicitly has an 'any' type because type ... Remove this comment to see the full error message
    if (this[rule]) {
      // @ts-expect-error TS(7052) FIXME: Element implicitly has an 'any' type because type ... Remove this comment to see the full error message
      return this[rule](a, b, c);
    }
    return undefined;
  }
}

export default Rules;
